import { useAtomValue } from "jotai/react";
import { useCallback, useMemo } from "react";
import { authAtom } from "@/atoms/auth";

export const useSystemHeader = () => {
  const auth = useAtomValue(authAtom);

  const user = useMemo(() => {
    return auth.type === "LoggedIn" ? auth.user : null;
  }, [auth]);

  const onClickCloseSystem = useCallback(() => {
    window.close();
  }, []);

  return {
    user,
    onClickCloseSystem,
  };
};
